import { ErrorMessage } from '@/app/components/ErrorMessage'
import React, { forwardRef } from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  startDecoration?: React.ReactNode
  endDecoration?: React.ReactNode
  errorMessage?: string
}

export type Ref = HTMLInputElement

export const Input = forwardRef<Ref, InputProps>(
  (
    {
      type,
      label,
      id,
      errorMessage,
      placeholder,
      startDecoration,
      endDecoration,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex flex-col gap-2">
        {label && (
          <label className="font-sans text-mydra-black" htmlFor={id}>
            {label}
          </label>
        )}
        <div
          className={`relative flex w-full items-center gap-2 px-4 py-2 ${
            props.disabled ? 'cursor-not-allowed bg-mydra-gray' : ''
          } overflow-hidden rounded-lg border border-gray-200 bg-white text-mydra-black focus-within:outline focus-within:outline-1 focus-within:outline-mydra-black ${
            props.className || ''
          } ${errorMessage && `border-red-500`}`}
        >
          {startDecoration && (
            <div className="flex h-full items-center justify-center">
              {startDecoration}
            </div>
          )}
          <input
            {...props}
            className="w-full flex-1 shrink-0 appearance-none border-none p-0 leading-7 shadow-none outline-none ring-0 focus:ring-0"
            type={type}
            ref={ref}
            id={id}
            placeholder={placeholder}
            style={{ fontSize: 'inherit' }}
          />
          {endDecoration && (
            <div className="flex h-full items-center justify-center">
              {endDecoration}
            </div>
          )}
        </div>
        <ErrorMessage message={errorMessage} className="text-left" />
      </div>
    )
  }
)

Input.displayName = 'Input'
